export default "__VITE_ASSET__DhkLYSJV__"